import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { MediaQueryService } from './services/media-query/media-query.service';
import { TranslateService } from '@ngx-translate/core';
import { ErrorService, LanguageService } from './services';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'depd-frontend';

  mobileSubscription: Subscription;

  languageLoaded: boolean = false;

  constructor(
    private mediaQueryService: MediaQueryService,
    private toastrService: ToastrService,
    private router: Router,
    private translate: TranslateService,
    private languageService: LanguageService,
    private errorService: ErrorService
  ) {
    this.languageService
      .setLocale()
      .then(() => {
        this.languageLoaded = true;
      })
      .catch(error => {
        this.errorService.onError(error);
        this.languageLoaded = true; // Fallback to true to avoid blocking the app
      });
    this.translate.onLangChange.subscribe(() => {
      this.languageLoaded = false;
      setTimeout(() => {
        this.languageLoaded = true;
      }, 10);
    });
  }

  ngOnInit() {
    this.mobileSubscription = this.mediaQueryService.mobile.subscribe((mobile: boolean) => {
      if (mobile) {
        this.toastrService.toastrConfig.positionClass = 'toast-bottom-center';
      } else {
        this.toastrService.toastrConfig.positionClass = 'toast-top-right';
      }
    });
    this.router.events.subscribe(event => {
      // uncomment this code if you want to cancel all pending requests on route change -> will currently break the app
      // if (event instanceof ActivationEnd) {
      //   this.httpService.cancelPendingRequests()
      // }
    });
  }

  ngOnDestroy() {
    if (this.mobileSubscription) {
      this.mobileSubscription.unsubscribe();
    }
  }
}
